<template>
    <MainContent title="Info de la reserva">
        <template v-slot:header>
            <div :class="'card-title pb-2 ' +  (!esMovil ? 'h4' : 'h6')">
                Información detallada sobre la reserva:
                <b-spinner v-if="loading" ariant="primary" />
                <span v-else>{{ reserva?.hash }}</span>
            </div>
            <div class="cart-tools mb-2">
                <router-link class="btn" :to="{ name: 'reservas', params: { hash: reserva?.hash } }" target="_blank">
                    <span>Ir a la reserva</span>
                </router-link>
            </div>
        </template>

        <template v-slot:content>
            <div v-if="loading" class="text-center my-5">
                <b-spinner variant="primary" label="Cargando..."/>
            </div>

            <div v-else-if="reserva">
                <b-card class="mb-4">
                    <b-card-header>
                        <h4>DATOS GENERALES</h4>
                    </b-card-header>
                    <b-card-body class="pb-0">
                        <b-list-group class="pl-3 ml-1 mt-3">
                            <b-row>
                                <b-col md="4">
                                    <p class="mb-2"><strong>Email:</strong> {{ reserva.email }}</p>
                                    <p v-if="reserva.email_comprado"><strong>Email Comprador:</strong> {{ reserva.email_comprado }}</p>
                                    <p><strong>Status:</strong> {{ formatStatus(reserva.status) }}</p>
                                </b-col>
                                <b-col md="4">
                                    <p class="mb-2"><strong>Fecha de creación:</strong> {{ formatDate(reserva.created_at) }}</p>
                                    <p><strong>Hash:</strong> {{ reserva.hash }}</p>
                                </b-col>
                                <b-col md="4">
                                    <p v-if="reserva.descuento"><strong>Descuento:</strong> {{ reserva.descuento }}%</p>
                                    <p v-if="reserva.localizador"><strong>Código de afiliados:</strong> {{ reserva.localizador }}</p>
                                </b-col>
                            </b-row>
                        </b-list-group>
                    </b-card-body>
                </b-card>

                <b-tabs>
                    <b-tab :title="texto + ' PENDIENTES DE COMPRAR'">
                        <b-card>
                            <template v-if="butacasPendientes.length || plazasPendientes.length">
                                <b-card-body style="max-height: 600px; overflow-y: auto;">
                                    <template v-if="butacasPendientes.length">
                                        <b-list-group>
                                            <b-list-group-item v-for="(butaca, index) in butacasPendientes" :key="'butaca-pendiente-'+index">
                                                <b-row>
                                                    <b-col md="4"><strong>Fila:</strong> {{ butaca.row }}</b-col>
                                                    <b-col md="4"><strong>Asiento:</strong> {{ butaca.seat }}</b-col>
                                                    <b-col md="4"><strong>Región:</strong> {{ butaca.region }}</b-col>
                                                </b-row>
                                                <p><strong>Concepto:</strong> {{ butaca.concept }}</p>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </template>
    
                                    <template v-if="plazasPendientes.length">
                                        <b-list-group>
                                            <b-list-group-item v-for="(plaza, index) in plazasPendientes" :key="'plaza-pendiente-'+index">
                                                <b-row>
                                                    <b-col md="4"><strong>Nombre:</strong> {{ plaza.nombre }}</b-col>
                                                    <b-col md="4"><strong>Sector:</strong> {{ plaza.sector }}</b-col>
                                                    <b-col md="4"><strong>Fila:</strong> {{ plaza.fila }}</b-col>
                                                </b-row>
                                                <p><strong>Concepto:</strong> {{ plaza.concept }}</p>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </template>
                                </b-card-body>
                                <hr/>
                                <b-card-footer style="background-color: white !important;">
                                    <b-row>
                                        <b-col class="text-left">
                                            <h4 class="mr-2">TOTAL DE {{ texto }} PENDIENTES DE COMPRAR: {{ butacasPendientes.length + plazasPendientes.length }}</h4>
                                        </b-col>
                                    </b-row>
                                </b-card-footer>
                            </template>
                            <b-card-body v-else>
                                <h4 class="p-3">
                                    No hay ninguna {{ texto.toLowerCase().slice(0, -1) }} pendiente de comprar.
                                </h4>
                            </b-card-body>
                        </b-card>
                    </b-tab>

                    <b-tab :title="texto + ' COMPRADAS'">
                        <b-card>
                            <template v-if="butacasCompradas.length || plazasCompradas.length">
                                <b-card-body style="max-height: 600px; overflow-y: auto;">
                                    <template v-if="butacasCompradas.length">
                                        <b-list-group>
                                            <b-list-group-item v-for="(butaca, index) in butacasCompradas" :key="'butaca-comprada-'+index">
                                                <b-row>
                                                    <b-col md="4"><strong>Fila:</strong> {{ butaca.row }}</b-col>
                                                    <b-col md="4"><strong>Asiento:</strong> {{ butaca.seat }}</b-col>
                                                    <b-col md="4"><strong>Región:</strong> {{ butaca.region }}</b-col>
                                                </b-row>
                                                <p><strong>Concepto:</strong> {{ butaca.concept }}</p>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </template>
    
                                    <template v-if="plazasCompradas.length">
                                        <b-list-group>
                                            <b-list-group-item v-for="(plaza, index) in plazasCompradas" :key="'plaza-comprada-'+index">
                                                <b-row>
                                                    <b-col md="4"><strong>Nombre:</strong> {{ plaza.nombre }}</b-col>
                                                    <b-col md="4"><strong>Sector:</strong> {{ plaza.sector }}</b-col>
                                                    <b-col md="4"><strong>Fila:</strong> {{ plaza.fila }}</b-col>
                                                </b-row>
                                                <p><strong>Concepto:</strong> {{ plaza.concept }}</p>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </template>
                                </b-card-body>
                                <hr/>
                                <b-card-footer style="background-color: white !important;">
                                    <b-row>
                                        <b-col class="text-left">
                                            <h4 class="mr-2">TOTAL DE {{ texto }} COMPRADAS: {{ butacasCompradas.length + plazasCompradas.length }}</h4>
                                        </b-col>
                                    </b-row>
                                </b-card-footer>
                            </template>
                            <b-card-body v-else>
                                <h4 class="p-3">
                                    No se ha comprado ninguna  {{ texto.toLowerCase().slice(0, -1) }}.
                                </h4>
                            </b-card-body>
                        </b-card>
                    </b-tab>
                </b-tabs>

                <b-card v-if="reserva.pedidos && reserva.pedidos.length" class="mb-4 mt-4">
                    <b-card-header>
                        <h4>PEDIDOS</h4>
                    </b-card-header>
                    <b-card-body>
                        <b-list-group style="max-height: 300px; overflow-y: auto;">
                            <b-list-group-item v-for="(pedido, index) in reserva.pedidos" :key="'pedido-'+index">
                                <b-row class="mb-3">
                                    <b-col md="4"><strong>Nº Pedido:</strong> {{ pedido.id }}</b-col>
                                    <b-col md="4"><strong>Fecha:</strong> {{ formatDate(pedido.date) }}</b-col>
                                    <b-col md="4"><strong>Email Comprador:</strong> {{ pedido.email_comprador }}</b-col>
                                </b-row>
                            </b-list-group-item>
                        </b-list-group>
                    </b-card-body>
                </b-card>
            </div>

            <div v-else class="alert alert-warning">
                No se encontró información de la reserva.
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";

    export default {
        props: {
            evento_id: {
                type: [Number, String],
                required: true
            },
            sesion_id: {
                type: [Number, String],
                required: true
            },
            reserva_id: {
                type: [Number, String],
                required: true
            }
        },
        data() {
            return {
                reserva: null,
                loading: false
            };
        },
        methods: {
            getReserva() {
                this.loading = true;

                const params = {
                    filters: {},
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    reserva_id: this.reserva_id
                };

                this.$store.dispatch(this.config.getVuexAlias("back.events.sesiones.reservas.show"), params).then(res => {
                    this.reserva = res.data.data;
                }).catch(error => {
                    this.$toast.error(error?.response?.data?.message || "Error al obtener la reserva");
                }).finally(() => {
                    this.loading = false;
                });
            },
            formatDate(dateString) {
                const date = new Date(dateString);
            
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();

                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');

                return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
            },
            formatStatus(status) {
                switch (status) {
                    case 0:
                        return 'Pendiente';
                    case 1:
                        return 'Comprada';
                }
            }   
        },
        computed: {
            esMovil() {
                return window.innerWidth < 768;
            },
            butacasPendientes() {
                return this.reserva?.butacas?.filter(butaca => butaca.concept === 'BLOQUEADO' && !butaca.comprado ) || [];
            },
            butacasCompradas() {
                return this.reserva?.butacas?.filter(butaca => butaca.concept !== 'BLOQUEADO' && butaca.comprado) || [];
            },
            plazasPendientes() {
                return this.reserva?.plazas?.filter(plaza => !plaza.comprado) || [];
            },
            plazasCompradas() {
                return this.reserva?.plazas?.filter(plaza => plaza.comprado) || [];
            },
            texto() {
                return this.reserva?.butacas?.length ? 'BUTACAS' : 'PLAZAS';
            }
        },
        created() {
            this.getReserva();
        },
        components: {
            MainContent
        }
    };
</script>

<style scoped>
.list-group-item {
    border: none;
    border-bottom: 1px solid #f1f1f1;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}
.list-group-item:last-child {
    border-bottom: none;
}
.card-body {
    padding: 4px !important;
}
::-webkit-scrollbar {
  width: 20px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #a8bbbf;
}
</style>
